import { createFileRoute } from '@tanstack/react-router'
import ListsPage from '@/features/dashboard/pages/lists'

export const Route = createFileRoute('/(app)/dashboard/lists/')({
  component: ListsPage,
})
